import React, { useEffect, useState } from 'react';
import { apiCallAsync, apiCall } from '../apiclient';
import { Spinner, Card, Button, Form, Table } from 'react-bootstrap';


export default function CatalogDelete(props) {

    const [deleteItems, setDeleteItems] = useState({});
    const [catalogList, setCatalogList] = useState([]);

    useEffect(() => {
        if (props.user !== undefined) {
            let catalogPath = '/catalogs?user=' + props.user.uuid;
            apiCall('get', catalogPath).then((res) => {
                setCatalogList(res.catalogs);
            }).catch((err) => {
                console.error('CatalogDelete.useEffect() Error ' + err);
            })
        }

    }, [props.user.uuid]);

    function updateDeleteList(evt, cat_uuid) {
        let dList = deleteItems;
        dList[cat_uuid] = evt.target.checked;
        setDeleteItems(dList);
    }

    async function runDelete(formEvent) {
        formEvent.preventDefault();
        let newList = [];
        catalogList.map(async (cat) => {
            if (deleteItems[cat.uuid] === true) {
                let catalogPath = '/catalogs/' + cat.uuid;
                try {
                    var res = await apiCallAsync("delete", catalogPath);
                } catch (ex) {
                    console.error('Error deleting ' + cat.uuid);
                    newList.push(cat);
                }
            } else {
                newList.push(cat);
            }
        })
        formElements = formEvent.target.elements;
        let tgt;
        for (var t=0, formElements; tgt = formElements[t++];) {
            if (tgt.type === 'checkbox') tgt.checked = false;
        }
        setCatalogList(newList);
        setDeleteItems({});
    }
    var moment = require('moment');
    if(catalogList.length > 0)
    return(
        <Card>
            <Card.Title className="mx-auto">Catalogs</Card.Title>
            <Form id='deleteForm' onSubmit={(evt) => runDelete(evt)} >
            <Form.Group controlId="catalogDelete">
            <Table striped bordered hover size="sm" className="table-fixed table table-responsive">
                <thead>
                    <tr>
                        <th>Select</th>
                        <th>Name (version)</th>
                        <th>Date/Time</th>
                    </tr>
                </thead>
                <tbody>
                    {catalogList.map((cat) => (
                        <tr>
                            <td><Form.Check id={cat.uuid} checked={deleteItems[cat.uuid]} 
                            onChange={(evt) => updateDeleteList(evt, cat.uuid)} /></td>
                            <td>{cat.catalog_name} ({cat.uuid.substr(cat.uuid.length - 6)})</td>
                            <td>{moment(cat.as_of_date).format('lll')}</td>
                        </tr>
                    ))}
                </tbody>
            </Table><p></p>

            <center><Button id='submit-deleteForm' className="mx-auto mb-3" variant="primary"
                    type="submit">Delete selected catalogs</Button></center>
            </Form.Group>
            </Form>
        </Card>
    );
    else return null;
}